import React from "react";
import { Col } from "react-bootstrap";
import FormInput from "./FormInput";

/**
 * Reusable form field component that handles input, validation errors, and error messages
 */
const FormField = ({
  // Field props
  value,
  onChange,
  onBlur,
  placeholder,
  type = "text",
  maxLength,
  minLength,
  required = false,
  className = "",

  // Validation props
  errors = {},
  validationRules = {},
  jobTypeId,

  // Layout props
  colProps = {},

  // Other props
  ...otherProps
}) => {
  const renderErrorMessages = () => {
    const errorMessages = [];

    // Check for basic validation errors
    Object.entries(validationRules).forEach(([errorKey, condition]) => {
      if (errors[errorKey] && condition) {
        errorMessages.push(
          <p key={errorKey} style={{ color: "red" }}>
            {getErrorMessage(errorKey)}
          </p>
        );
      }
    });

    // Check for content validation errors (profanity, etc.)
    const contentErrorKeys = Object.keys(errors).filter(
      (key) => key.includes("ContentError") && errors[key]
    );

    contentErrorKeys.forEach((errorKey) => {
      errorMessages.push(
        <p key={errorKey} style={{ color: "red" }}>
          Disallowed Content
        </p>
      );
    });

    return errorMessages;
  };

  const getErrorMessage = (errorKey) => {
    const errorMessages = {
      companyError: "Company is required",
      cityError: "City is required",
      countryStateError: "State/Province is required",
      contactNameError: "Contact Name is required",
      positionError: "Position is required",
      emailError: "Email is required",
      addressError: "Address is required",
      descriptionError: "Description is required",
      phoneValidError: "Enter valid phone number",
      zipValidError: "Enter valid ZIP",
      companyNameValidError: "Enter valid company name",
      nameValidError: "Enter valid Name",
      emailValidError: "Enter valid Email",
      positionValidError: "Enter valid Position",
      cityValidError: "Enter valid City",
      stateValidError: "Enter valid State",
      payRateError: "Enter valid pay rate",
      linkError: "Post Link is required",
      linkValidError: "Enter valid post link",
    };

    return errorMessages[errorKey] || "Invalid input";
  };

  return (
    <Col {...colProps}>
      <FormInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        type={type}
        maxLength={maxLength}
        minLength={minLength}
        required={required ? "required" : undefined}
        className={className}
        {...otherProps}
      />
      {renderErrorMessages()}
    </Col>
  );
};

export default FormField;
